import { PillButton } from '@rocco/components/pill-button';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import { SortOption } from '@rocco/types/enum/sort-option';

interface RefineSortPillsProps {
    /** The staged sort, from the sheet's local filter states. */
    sort?: SortOption;
    onSortChange: (sort: SortOption) => void;
}

/**
 * Sort as a single-select pill row — the whole option set stays visible in
 * ~60px instead of hiding behind an accordion door. Selection stages into
 * the sheet's local states and commits with the CTA.
 */
export const RefineSortPills = (props: RefineSortPillsProps) => {
    const { sort, onSortChange } = props;
    const { sortOptions } = useFiltersContext();

    if (sortOptions.length === 0) return null;

    const activeSort =
        sort ??
        sortOptions.find((option) => option.selected)?.value ??
        SortOption.Featured;

    return (
        <section aria-label="Sort by">
            <div className="flex min-h-11 items-center text-base font-medium">
                Sort by
            </div>
            <div
                role="radiogroup"
                aria-label="Sort by"
                className="-mx-6 flex scrollbar-hidden gap-2 overflow-x-auto px-6 pb-3"
            >
                {sortOptions.map((option) => (
                    <PillButton
                        key={option.value}
                        role="radio"
                        aria-checked={activeSort === option.value}
                        size="sm"
                        selected={activeSort === option.value}
                        className="shrink-0"
                        onClick={() => onSortChange(option.value)}
                    >
                        {option.title}
                    </PillButton>
                ))}
            </div>
        </section>
    );
};
